@if (activated && !hideLayout) {
  <lm-form-content-template #LMFormTemplateComponent
    [displayPanelId]="displayPanelId"
    [fromDataView]="fromDataView"
    [sourceDataView]="sourceDataView"
    [formUrlInfo]="formUrlInfo"
    [formSpec]="formSpec"
    [placeHolder]="placeHolder"
    [formOptions]="formOptions"
    [dynamicChildVisibility]="dynamicChildVisibility"
    [specFields]="specFields"
    [layout]="layout"
    [displayWhenIndex]="displayWhenIndex"
    (contentModified)="onContentModified($event)"
    (fieldEvent)="onFieldEvent($event)"
    (formTemplateLoading)="onFormTemplateLoading($event)"
    (formTemplateLoaded)="onFormTemplateLoaded($event)"
  ></lm-form-content-template>
}
